import api from './index';

export const accountingAPI = {
  getTransactions: (params) => api.get('/accounting', { params }),
  addTransaction: (data) => api.post('/accounting', data),
  getRate: () => api.get('/accounting/rate'),
};
